import { z } from 'zod/v3';
import { DataObjectRelationVersionSchema } from './DataObjectVersionSchema';
import { SystemClassifierItemSchema } from '../../systemClassifier';
import { zIsoDate } from '../../common/utils';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';

const DataObjectTypeSchema = z.enum(['IN', 'OUT'] as const);

const DataObjectRelationNodeProcessingDataSchema = z.object({
  code: z.string(),
  hasAccess: z.boolean(),
  processingEventId: z.number().nullable(),
  processingDataObjectId: z.number().nullable(),
  missingSourceData: z.boolean(),
  calculationErrors: z.boolean(),
  validationErrorLevelId: z.number().nullable(),
  hasActiveProcessing: z.boolean(),
  loadingExists: z.boolean(),
});

export const DataObjectRelationsTableRowDtoSchema = z.object({
  sequenceNumber: z.number(),
  relationType: z.string(),
  sourceDescriptionId: z.number().nullable(),
  sourceDescriptionCodeName: z.string().nullable(),
  sourceGroupId: z.number().nullable(),
  sourceGroupCodeName: z.string().nullable(),
  sourceDataObjectType: DataObjectTypeSchema,
  sourceProcessingData: DataObjectRelationNodeProcessingDataSchema.nullable(),
  sourceVersion: DataObjectRelationVersionSchema.nullable(),
  sourceFrequency: SystemClassifierItemSchema.nullable(),
  sourceValueDate: zIsoDate().nullable(),
  sourceTime: zIsoDateTime().nullable(),
  targetDescriptionId: z.number().nullable(),
  targetDescriptionCodeName: z.string().nullable(),
  targetGroupId: z.number().nullable(),
  targetGroupCodeName: z.string().nullable(),
  targetDataObjectType: DataObjectTypeSchema,
  targetProcessingData: DataObjectRelationNodeProcessingDataSchema.nullable(),
  targetVersion: DataObjectRelationVersionSchema.nullable(),
  targetFrequency: SystemClassifierItemSchema.nullable(),
  targetValueDate: zIsoDate().nullable(),
  targetTime: zIsoDateTime().nullable(),
});

export const DataObjectRelationsTableDtoSchema = z.array(
  DataObjectRelationsTableRowDtoSchema,
);
